import { AbstractControl } from '@angular/forms';
import { Util } from '../utils/util';

export class OmniValidators {
	static whiteSpace(control: AbstractControl) {
		if (control && control.value && !control.value.replace(/\s/g, '').length) {
			return { 'whiteSpace': true };
		}

		return null;
	}

	static completeName(control: AbstractControl) {
		if (control && control.value && !control.value.match(/[a-zA-Z] [a-zA-Z]/)) {
			return { 'completeName': true };
		}

		return null;
	}

	private static charToValue(ch: string): number {
		const code = ch.toUpperCase().charCodeAt(0);
		if ((code >= 48 && code <= 57) || (code >= 65 && code <= 90)) {
			return code - 48;
		}
		return -1;
	}

	private static isValidCnpjAlphanumeric(cnpj: string): boolean {
		cnpj = cnpj.toUpperCase();

		if (cnpj.length !== 14) {
			return false;
		}

		if (!/^[A-Z0-9]{12}$/.test(cnpj.substring(0, 12))) {
			return false;
		}

		if (!/^\d{2}$/.test(cnpj.substring(12))) {
			return false;
		}

		if (/^(.)\1{13}$/.test(cnpj)) {
			return false;
		}

		const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
		let sum = 0;
		for (let i = 0; i < 12; i++) {
			sum += OmniValidators.charToValue(cnpj[i]) * weights1[i];
		}
		let remainder = sum % 11;
		const digit1 = remainder < 2 ? 0 : 11 - remainder;

		if (digit1 !== parseInt(cnpj[12], 10)) {
			return false;
		}

		const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
		sum = 0;
		for (let i = 0; i < 13; i++) {
			sum += OmniValidators.charToValue(cnpj[i]) * weights2[i];
		}
		remainder = sum % 11;
		const digit2 = remainder < 2 ? 0 : 11 - remainder;

		return digit2 === parseInt(cnpj[13], 10);
	}

	static isValidCpfCnpj(control: AbstractControl) {
		if (!control || !control.value) {
			return null;
		}

		const raw = control.value.replace(/[\.\-\/\s]/g, '');
		const hasLetters = Util.hasLetters(raw);

		if (hasLetters) {
			if (raw.length !== 14) {
				return { cpfCnpjNotValid: true };
			}
			if (!OmniValidators.isValidCnpjAlphanumeric(raw)) {
				return { cpfCnpjNotValid: true };
			}
			return null;
		}

		const cpfCnpj = raw.replace(/\D/g, '');

		if (cpfCnpj.length === 11) {
			let numbers, digits, sum, i, result, equalDigits;
			equalDigits = 1;

			for (i = 0; i < cpfCnpj.length - 1; i++) {
				if (cpfCnpj.charAt(i) !== cpfCnpj.charAt(i + 1)) {
					equalDigits = 0;
					break;
				}
			}

			if (!equalDigits) {
				numbers = cpfCnpj.substring(0, 9);
				digits = cpfCnpj.substring(9);
				sum = 0;
				for (i = 10; i > 1; i--) {
					sum += numbers.charAt(10 - i) * i;
				}

				result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

				if (result !== Number(digits.charAt(0))) {
					return { cpfCnpjNotValid: true };
				}
				numbers = cpfCnpj.substring(0, 10);
				sum = 0;

				for (i = 11; i > 1; i--) {
					sum += numbers.charAt(11 - i) * i;
				}
				result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

				if (result !== Number(digits.charAt(1))) {
					return { cpfCnpjNotValid: true };
				}
				return null;
			} else {
				return { cpfCnpjNotValid: true };
			}
		}

		if (cpfCnpj.length === 14) {
			if (
				cpfCnpj === '1000000000000001' ||
				cpfCnpj === '1111111111111111' ||
				cpfCnpj === '1222222222222221' ||
				cpfCnpj === '1333333333333331' ||
				cpfCnpj === '1444444444444441' ||
				cpfCnpj === '1555555555555551' ||
				cpfCnpj === '1666666666666661' ||
				cpfCnpj === '1777777777777771' ||
				cpfCnpj === '888888888888881' ||
				cpfCnpj === '1999999999999991'
			) {
				return { cpfCnpjNotValid: true };
			}

			if (!OmniValidators.isValidCnpjAlphanumeric(cpfCnpj)) {
				return { cpfCnpjNotValid: true };
			}

			return null;
		}

		return null;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/validators.ts